import React from 'react';
import { Card } from './ui/card';
import { MapPin } from 'lucide-react';

const Regions = () => {
  const regions = [
    { id: 'zurich', name: 'Zürich' },
    { id: 'winterthur', name: 'Winterthur' },
    { id: 'uster', name: 'Uster' },
    { id: 'dubendorf', name: 'Dübendorf' },
    { id: 'dietikon', name: 'Dietikon' },
    { id: 'wetzikon', name: 'Wetzikon' },
    { id: 'basel', name: 'Basel' },
    { id: 'other', name: 'Weitere Orte auf Anfrage' }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-slate-900 to-blue-900 text-white">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold mb-4">
              Für Sie im Einsatz in Zürich und Umgebung
            </h2>
            <p className="text-xl text-slate-200">
              Wir übernehmen Malerarbeiten in Zürich sowie in vielen umliegenden Regionen
            </p>
          </div>

          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-4">
            {regions.map((region) => (
              <Card
                key={region.id}
                className="p-6 bg-white/10 backdrop-blur-sm border-2 border-white/20 hover:bg-white/20 transition-all duration-300 cursor-pointer group"
              >
                <div className="flex items-center gap-3">
                  <MapPin className="w-5 h-5 text-blue-300 group-hover:text-blue-200 transition-colors" />
                  <span className="text-lg font-medium text-white">{region.name}</span>
                </div>
              </Card>
            ))}
          </div>

          <div className="mt-12 text-center">
            <p className="text-lg text-slate-200">
              <strong className="text-white">Kantone:</strong> Thurgau, Zürich, Aargau, Basel
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Regions;